import { useState } from 'react';
import { useInView } from '../../../hooks/useInView';

const WA_LINK = 'https://wa.me/5511984333601?text=Ol%C3%A1%2C%20tenho%20interesse%20em%20saber%20mais%20sobre%20os%20servi%C3%A7os%20jur%C3%ADdicos%20imobili%C3%A1rios.';

const areas = [
  {
    icon: 'ri-building-2-line',
    title: 'Incorporação Imobiliária',
    description:
      'Assessoria jurídica completa em todas as etapas do processo de incorporação, desde a viabilidade até o registro.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Regularização de Imóveis',
    description:
      'Soluções para imóveis em situação irregular, garantindo plena segurança jurídica ao seu patrimônio.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Levantamento de Área',
    description:
      'Assessoria jurídica no processo de levantamento planimétrico e demarcação de terrenos e imóveis.',
  },
  {
    icon: 'ri-file-edit-line',
    title: 'Retificação de Registro',
    description:
      'Correção de dados e informações incorretas em registros imobiliários, com segurança e agilidade.',
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Unificação de Lotes',
    description:
      'Processo jurídico para fusão de dois ou mais lotes contíguos em um único imóvel devidamente registrado.',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Due Diligence',
    description:
      'Auditoria jurídica minuciosa para identificar riscos antes de transações imobiliárias de alto valor.',
  },
  {
    icon: 'ri-home-smile-line',
    title: 'Usucapião',
    description:
      'Assessoria jurídica completa para aquisição de propriedade por posse prolongada, garantindo o reconhecimento legal do seu direito ao imóvel.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Inventários',
    description:
      'Condução de inventários judiciais e extrajudiciais com agilidade e segurança, assegurando a correta partilha e transferência de bens imóveis.',
  },
  {
    icon: 'ri-shake-hands-line',
    title: 'Assessoria em Compra e Venda',
    description:
      'Assessoria jurídica especializada em transações imobiliárias, desde a análise documental até a assinatura do contrato, com total segurança jurídica.',
  },
];

export default function PracticeAreas() {
  const { ref: titleRef, inView: titleIn } = useInView();

  return (
    <section id="atuacao" className="w-full py-24 md:py-32" style={{ background: '#0A2A52' }}>
      <div className="max-w-6xl mx-auto px-6 md:px-12">

        {/* Section header */}
        <div
          ref={titleRef}
          className={`text-center mb-14 transition-all duration-1000 ${titleIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="h-px w-16" style={{ background: 'linear-gradient(90deg, transparent, #D4AF37)' }}></div>
            <span className="font-sans text-xs tracking-[3px] uppercase font-medium" style={{ color: '#D4AF37' }}>
              Áreas de Atuação
            </span>
            <div className="h-px w-16" style={{ background: 'linear-gradient(90deg, #D4AF37, transparent)' }}></div>
          </div>
          <h2 className="font-serif text-3xl md:text-5xl font-bold" style={{ color: '#F5F5F5' }}>
            Especialização que gera{' '}
            <span style={{ color: '#D4AF37' }}>resultados</span>
          </h2>
          <p className="font-sans text-sm md:text-base font-light mt-4 max-w-2xl mx-auto" style={{ color: '#D9D9D9' }}>
            Atuação técnica e estratégica em todas as frentes do direito imobiliário,
            com foco em eficiência e segurança jurídica.
          </p>
        </div>

        {/* Mobile carousel */}
        <div className="block sm:hidden">
          <MobileCarousel />
        </div>

        {/* Desktop / Tablet carousel */}
        <div className="hidden sm:block">
          <DesktopCarousel />
        </div>

      </div>
    </section>
  );
}

/* ─── Desktop Carousel (3 visible at once, slide by 1) ─── */
function DesktopCarousel() {
  const total = areas.length;
  const visible = 3;
  const maxIndex = total - visible; // 0..4
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => Math.max(c - 1, 0));
  const next = () => setCurrent((c) => Math.min(c + 1, maxIndex));

  return (
    <div className="flex flex-col gap-8">
      {/* Track wrapper */}
      <div className="relative overflow-hidden">
        {/* Cards track — 3 cards fill 100%, translate shifts by card width */}
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${(current / visible) * 100}%)` }}
        >
          {areas.map((area, i) => (
            <div
              key={i}
              className="flex-shrink-0 px-3"
              style={{ width: `${100 / visible}%` }}
            >
              <AreaCard area={area} index={i} />
            </div>
          ))}
        </div>
      </div>

      {/* Controls row */}
      <div className="flex items-center justify-center gap-6">
        {/* Prev */}
        <button
          onClick={prev}
          disabled={current === 0}
          className="w-10 h-10 flex items-center justify-center rounded-sm cursor-pointer transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed"
          style={{ background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.35)', color: '#D4AF37' }}
          aria-label="Anterior"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>

        {/* Dots — one per "page" (index 0..maxIndex) */}
        <div className="flex items-center gap-2">
          {Array.from({ length: maxIndex + 1 }).map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className="cursor-pointer transition-all duration-200"
              style={{
                width: i === current ? '20px' : '8px',
                height: '8px',
                borderRadius: '4px',
                background: i === current ? '#D4AF37' : 'rgba(212,175,55,0.3)',
                border: 'none',
                padding: 0,
              }}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>

        {/* Next */}
        <button
          onClick={next}
          disabled={current === maxIndex}
          className="w-10 h-10 flex items-center justify-center rounded-sm cursor-pointer transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed"
          style={{ background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.35)', color: '#D4AF37' }}
          aria-label="Próximo"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>
      </div>

      {/* Counter */}
      <p className="text-center font-sans text-xs" style={{ color: 'rgba(212,175,55,0.6)' }}>
        {current + 1} / {maxIndex + 1}
      </p>
    </div>
  );
}

/* ─── Mobile Carousel (1 card at a time) ─── */
function MobileCarousel() {
  const [current, setCurrent] = useState(0);
  const total = areas.length;

  const prev = () => setCurrent((c) => (c - 1 + total) % total);
  const next = () => setCurrent((c) => (c + 1) % total);

  const area = areas[current];

  return (
    <div className="flex flex-col items-center gap-6">
      {/* Card */}
      <div
        className="w-full flex flex-col items-center justify-between text-center p-8 rounded-sm"
        style={{
          background: 'rgba(18,59,115,0.4)',
          border: '1px solid rgba(212,175,55,0.25)',
          minHeight: '320px',
        }}
      >
        <div
          className="w-16 h-0.5 mb-4"
          style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }}
        />

        <div
          className="w-14 h-14 flex items-center justify-center rounded-sm mb-4"
          style={{ background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.3)' }}
        >
          <i className={`${area.icon} text-2xl`} style={{ color: '#D4AF37' }}></i>
        </div>

        <h3 className="font-serif text-base font-semibold mb-4 leading-snug" style={{ color: '#F5F5F5' }}>
          {area.title}
        </h3>

        <p className="font-sans text-sm leading-relaxed flex-1 px-2 mb-6" style={{ color: '#D9D9D9' }}>
          {area.description}
        </p>

        <a
          href={WA_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 font-sans text-xs font-semibold tracking-wider uppercase whitespace-nowrap cursor-pointer"
          style={{ color: '#D4AF37' }}
        >
          <i className="ri-whatsapp-line"></i>
          Falar com advogado
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      {/* Controls */}
      <div className="flex items-center gap-6">
        <button
          onClick={prev}
          className="w-10 h-10 flex items-center justify-center rounded-sm cursor-pointer transition-all duration-200"
          style={{ background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.35)', color: '#D4AF37' }}
          aria-label="Anterior"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>

        <div className="flex items-center gap-2">
          {areas.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className="cursor-pointer transition-all duration-200"
              style={{
                width: i === current ? '20px' : '8px',
                height: '8px',
                borderRadius: '4px',
                background: i === current ? '#D4AF37' : 'rgba(212,175,55,0.3)',
                border: 'none',
                padding: 0,
              }}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>

        <button
          onClick={next}
          className="w-10 h-10 flex items-center justify-center rounded-sm cursor-pointer transition-all duration-200"
          style={{ background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.35)', color: '#D4AF37' }}
          aria-label="Próximo"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>
      </div>

      <p className="font-sans text-xs" style={{ color: 'rgba(212,175,55,0.6)' }}>
        {current + 1} / {total}
      </p>
    </div>
  );
}

/* ─── Single Card ─── */
function AreaCard({ area, index }: { area: typeof areas[0]; index: number }) {
  const { ref, inView } = useInView();

  return (
    <div
      ref={ref}
      className="group relative aspect-square flex flex-col items-center justify-between text-center cursor-pointer transition-all duration-700 p-8"
      style={{
        background: 'rgba(18,59,115,0.4)',
        border: '1px solid rgba(212,175,55,0.15)',
        borderRadius: '4px',
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(32px)',
        transitionDelay: `${index * 80}ms`,
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLDivElement).style.background = 'rgba(18,59,115,0.75)';
        (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(212,175,55,0.5)';
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLDivElement).style.background = 'rgba(18,59,115,0.4)';
        (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(212,175,55,0.15)';
      }}
    >
      <div
        className="absolute top-0 left-0 right-0 h-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }}
      ></div>

      <div className="flex flex-col items-center gap-4 w-full">
        <div
          className="w-14 h-14 flex items-center justify-center rounded-sm transition-all duration-300"
          style={{ background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.3)' }}
        >
          <i className={`${area.icon} text-2xl`} style={{ color: '#D4AF37' }}></i>
        </div>
        <h3 className="font-serif text-base font-semibold leading-snug" style={{ color: '#F5F5F5' }}>
          {area.title}
        </h3>
      </div>

      <p
        className="font-sans text-sm leading-relaxed px-2"
        style={{
          color: '#D9D9D9',
          display: '-webkit-box',
          WebkitLineClamp: 4,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {area.description}
      </p>

      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 font-sans text-xs font-semibold tracking-wider uppercase whitespace-nowrap cursor-pointer transition-all duration-300"
        style={{ color: '#D4AF37' }}
        onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#E5C76B'; }}
        onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#D4AF37'; }}
      >
        <i className="ri-whatsapp-line"></i>
        Falar com advogado
        <i className="ri-arrow-right-line"></i>
      </a>
    </div>
  );
}
